import { Spinner, Stack } from '@optimus-web/core';

export const DefaultLoading: React.FC = () => (
    <Stack vertical itemAlignment="center">
        <Spinner />
    </Stack>
);
